const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF;

export const StudioAddressBarcodeCommandURL = {
    CreateStudioAddressBarcode: Backofficebff + '/v1/AddressBarcodeDefinition/create-address-barcode-definition',
    UpdateStudioAddressBarcode: Backofficebff + '/v1/AddressBarcodeDefinition/update-address-barcode-definition',
};
